module.exports = __webpack_public_path__ + "img/mask2.46f681cc.jpeg";